import Link from "next/link";
import { IArticle, IArticleFields } from "../../@types/generated/contentful";
import Layout from "../../components/Layout";
import { fetchArticles } from "../../contentful/article";
import Hero2 from "../../components/Hero2";
import Button from "../../components/Button";
import { formatDate } from "../../utils/formatters";
import Image from "next/image";
import SEO from "../../components/SEO";

// type the stff as optional string

function Blog({ articles, featured }) {
  return (
    <div className="bg-white">
      <SEO
        currentURL={`${process.env.NEXT_PUBLIC_ROOT_URL}/blog`}
        title="Blog"
        siteTitle="Movi Autos"
      />
      <Hero2
        renderTitle={() => (
          <h1 className="text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl pr-2">
            <span className="inline-block text-orange-500 lg:text-black bg-white lg:bg-transparent pb-1.5 lg:pb-none px-4 lg:px-0 rounded-md leading-relaxed lg:leading-none shadow-md lg:shadow-none">
              {featured.title}
            </span>
          </h1>
        )}
        renderCTA={() => (
          <Button link={`/blog/${featured.slug}`} text="Leer artículo" />
        )}
        subtitle={featured.description}
        image={`https:${featured.cover.fields.file.url}`}
      />

      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-16">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Más de nuestro blog
          </h2>
          <p className="mt-2 text-lg leading-8 text-gray-600">
            Leé nuestros artículos y conocé más acerca de Movi y el mundo
            automotriz.
          </p>
        </div>
        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-y-20 gap-x-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {articles.map((article) => {
            const { author } = article;
            return (
              <article
                key={article.title}
                className="flex flex-col items-start justify-between"
              >
                <div className="relative w-full aspect-[16/9] bg-gray-100 sm:aspect-[2/1] lg:aspect-[3/2]">
                  <Link href={`/blog/${article.slug}`}>
                    <Image
                      src={`https:${article.cover.fields.file.url}`}
                      alt=""
                      layout="fill"
                      objectFit="cover"
                      className="rounded-lg hover:opacity-70 cursor-pointer"
                    />
                  </Link>
                </div>
                <div className="max-w-xl">
                  <div className="mt-8 flex items-center gap-x-4 text-xs">
                    <time
                      dateTime={article.updatedDate}
                      className="text-gray-500"
                    >
                      {formatDate(article.updatedDate)}
                    </time>
                    <a
                      // href={article.category.href}
                      className="relative z-10 rounded-full bg-gray-50 py-1.5 px-3 font-medium text-gray-600 hover:bg-gray-100"
                    >
                      {/* Categoria */}
                      {/* {article.category.title} */}
                    </a>
                  </div>
                  <div className="group relative">
                    <h3 className="mt-3 ">
                      <Link href={`/blog/${article.slug}`}>
                        <span className="text-lg font-semibold leading-6 text-gray-900 hover:text-orange-500 cursor-pointer">
                          {article.title}
                        </span>
                      </Link>
                    </h3>
                    <p className="mt-5 text-sm leading-6 text-gray-600 line-clamp-3">
                      {article.description}
                    </p>
                  </div>
                  <div className="relative mt-8 flex items-center gap-x-4">
                    <img
                      src={author.fields.avatar.fields.file.url}
                      alt=""
                      className="h-10 w-10 rounded-full bg-gray-100"
                    />
                    <div className="text-sm leading-6">
                      <p className="font-semibold text-gray-900">
                        <a>
                          <span className="absolute inset-0" />
                          {author.fields.name}
                        </a>
                      </p>
                      {/* <p className="text-gray-600">role</p> */}
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </div>
  );
}

Blog.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

export async function getStaticProps(context) {
  const res = await fetchArticles();
  const articles: Array<IArticleFields> = await res.map((p: IArticle) => {
    return p.fields;
  });

  const featuredIndex = articles.findIndex((article) => article.featured);

  return {
    props: {
      articles,
      featured: articles[featuredIndex],
    },
  };
}

export default Blog;
